function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "video-brands_svg__cls-1",
  d: "M49.65 92.47H23.69c-9.57 0-17.35-7.78-17.35-17.35V22.36C6.33 12.79 14.12 5 23.69 5h52.76c9.57 0 17.35 7.78 17.35 17.35v30.33h-5V22.36c0-6.81-5.54-12.35-12.35-12.35H23.69c-6.81 0-12.35 5.54-12.35 12.35v52.77c0 6.81 5.54 12.35 12.35 12.35h25.96v5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "video-brands_svg__cls-1",
  d: "M38.2 68.8c-.45 0-.91-.12-1.32-.35a2.65 2.65 0 01-1.33-2.29v-37c0-.94.5-1.81 1.32-2.28.81-.47 1.82-.47 2.64 0l32.05 18.51c.81.47 1.32 1.35 1.32 2.28s-.5 1.81-1.32 2.28l-32.05 18.5c-.4.24-.86.35-1.32.35zm-1.17-4.69s-.01 0-.02.01h.02zm3.53-30.88v28.83l24.96-14.41-24.96-14.41z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "video-brands_svg__cls-1",
  d: "M86.35 128.3c-21.63 0-39.22-17.59-39.22-39.22s17.59-39.22 39.22-39.22 39.22 17.59 39.22 39.22-17.59 39.22-39.22 39.22zm0-73.44c-18.87 0-34.22 15.35-34.22 34.22s15.35 34.22 34.22 34.22 34.22-15.35 34.22-34.22-15.35-34.22-34.22-34.22z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "video-brands_svg__cls-1",
  d: "M108.46 68.4c1.04 8.39-1.52 15.66-6.46 22.22-2.1 2.79-4.53 5.28-7.29 7.43-.28.22-.37.45-.37.79.01 1.6-.03 3.2.02 4.8.08 2.66-.98 4.78-3.02 6.39-.95.75-2 1.39-3.06 1.98-1.35.75-2.76 1.4-4.14 2.09-.13.07-.28.12-.47.2v-.62c0-3.06 0-6.12-.01-9.19 0-.26-.13-.58-.31-.76-3.33-3.36-6.68-6.7-10.02-10.05-.24-.24-.48-.34-.82-.34-3.04.01-6.09 0-9.13 0h-.62c.05-.14.07-.25.12-.35 1.09-2.08 2.11-4.2 3.3-6.21 1.07-1.8 2.58-3.2 4.67-3.8.72-.21 1.5-.29 2.26-.31 1.69-.04 3.38-.03 5.06 0 .4 0 .63-.13.87-.43 4.39-5.51 9.78-9.7 16.4-12.23 2.82-1.08 5.73-1.67 8.76-1.62 1.46.03 2.92 0 4.28 0zM97.91 82.64a3.544 3.544 0 00-3.56-3.54 3.56 3.56 0 00-3.56 3.55c0 1.96 1.64 3.6 3.6 3.58a3.566 3.566 0 003.52-3.59z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "video-brands_svg__cls-1",
  d: "M76.4 105.88c-2.57 3.42-6.35 4.65-10.56 5.29.81-4.08 1.83-7.96 5.31-10.56 1.74 1.74 3.5 3.51 5.25 5.27z"
});

function SvgVideoBrands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgVideoBrands;